import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../css/header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="text-white header">
      <div className="container d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img src="/logo.png" alt="Boduroğlu Otomotiv" className="me-1 logo-img" />
          <h1 className="h3 mb-0">Boduroğlu Otomotiv</h1>
        </div>

        {/* Hamburger Menu Icon */}
        <button className="btn btn-light d-md-none" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>

        {/* Offcanvas Menu for mobile */}
        <div className={`offcanvas offcanvas-start ${menuOpen ? 'show' : ''}`} tabIndex="-1" id="offcanvasMenu" aria-labelledby="offcanvasMenuLabel">
        <div className="offcanvas-header">
  <h5 className="offcanvas-title" id="offcanvasMenuLabel">Boduroğlu Otomotiv</h5>
  <button type="button" className="btn-close text-reset" onClick={() => setMenuOpen(false)} aria-label="Close"></button>
</div>
          <div className="offcanvas-body">
            <nav className="d-flex flex-column gap-3">
            <NavLink to="/" className="nav-item text-decoration-none" activeClassName="active" onClick={() => setMenuOpen(false)}>Ana Sayfa</NavLink>
<NavLink to="/hakkimizda" className="nav-item text-decoration-none" activeClassName="active" onClick={() => setMenuOpen(false)}>Hakkımızda</NavLink>
<NavLink to="/hizmetler" className="nav-item text-decoration-none" activeClassName="active" onClick={() => setMenuOpen(false)}>Hizmetler</NavLink>
<NavLink to="/iletisim" className="nav-item text-decoration-none" activeClassName="active" onClick={() => setMenuOpen(false)}>İletişim</NavLink>

            </nav>
          </div>
        </div>

        {/* Desktop Menu */}
        <nav className="d-none d-md-flex gap-3">
          <NavLink to="/" className="text-white text-decoration-none menu-item">Ana Sayfa</NavLink>
          <NavLink to="/hakkimizda" className="text-white text-decoration-none menu-item">Hakkımızda</NavLink>
          <NavLink to="/hizmetler" className="text-white text-decoration-none menu-item">Hizmetler</NavLink>
          <NavLink to="/iletisim" className="text-white text-decoration-none menu-item">İletişim</NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;
